require('./bootstrap');

import IMask from 'imask';
window.IMask = IMask;

$(function () {
    
});

$.fn.imask = function(maskOptions) {
    return this.each(function () {
        IMask(this, maskOptions);
    });
};